import { createContext, useState } from 'react';

export const FarmContext = createContext({
  farmContextValue: null,
  setFarmContextValue: () => {},
});
export default function FarmContextProvider({ children }) {
  const [farmContextValue, setFarmContextValue] = useState(null);

  return <FarmContext.Provider value={{ farmContextValue, setFarmContextValue }}>{children}</FarmContext.Provider>;
}
